import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import { Button } from "reactstrap";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { Pagination } from "antd";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import isConsultant from "../services/isConsultant";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;
//disable date logic -{Lovejot- 23-08-2022}

const disabledDate = (current) => {
  // 90 DAYS GAP AND DISABLE TOMORROW
  return (
    current.isBefore(moment().subtract(90, "day")) ||
    current > moment().endOf("day")
  );
};
const LogsStatus = (props) => {
  const [defaultDate, setDefaultDate] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [load, setLoad] = useState(false);

  const [canViewOtpLogs, setCanViewOtpLogs] = useState(false);
  const [canDownloadOtpLogs, setCanDownloadOtpLogs] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "otp_logs_module",
        "view_otp_logs"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "otp_logs_module",
        "download"
      );
      setCanViewOtpLogs(viewAllowed);
      setCanDownloadOtpLogs(downloadAllowed);
    } catch (err) {
      console.error("Error checking OTP logs permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  useEffect(() => {
    loadCSV();
  }, [defaultDate]);

  const [current, setCurrent] = useState(1);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const loadCSV = () => {
    setLoad(true);
    axios
      .get(
        `/OTPAutentication/OTPHitsLogs?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        //  console.log("RES", res.data);
        setCsvData(res.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        message.warning("Error Occured", 2);
        setLoad(false);
      });
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    console.log("date is ", value, dateString);
    if (value === null) {
      setCurrent(1);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setCurrent(1);
      setDefaultDate(dateString);
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  //CSV DATA
  const exportType = "csv";
  let fileName = `OTP_Logs_Status_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;
  const data = csvData;
  const downloadCSV = () => {
    setCurrent(1);
    exportFromJSON({ data, fileName, exportType });
  };

  return (
    <div>
    {!isConsultant() && <Dashboard title="OTP Logs Status">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      {canViewOtpLogs ? (
        <div className="row p-3 border mb-2 bg-white cursor-pointer">
          <RangePicker
            format="YYYY-MM-DD"
            defaultValue={[moment(), moment()]}
            onChange={handleDate}
            onOk={onOk}
            disabledDate={disabledDate}
            placeholder={[
              moment(new Date()).format("YYYY-MM-DD"),
              moment(new Date()).format("YYYY-MM-DD"),
            ]}
          />
          {canDownloadOtpLogs && (
            <div className="col-md-2">
              <button className="btn btn-primary btn-block" onClick={downloadCSV}>
                Download CSV
              </button>
            </div>
          )}
        </div>
      ) : (
        !load && <Card className="p-3">You are not authorized to view this report.</Card>
      )}

      {/* <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
        <table className="table bg-white ">
          <thead>
            <tr>
              <th>Name</th>
              <th>OTP</th>
              <th>OTP Status</th>
              <th>Name</th>
              <th>OTP</th>
              <th>OTP Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Name</td>
              <td>OTP</td>
              <td>OTP Status</td>
              <td>Name</td>
              <td>OTP</td>
              <td>OTP Status</td>
            </tr>
          </tbody>
        </table>
        <Pagination current={current} onChange={onChange} total={50} />
      </div> */}
    </Dashboard>}
    </div>
  );
};

export default LogsStatus;
